import { Component, inject } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { select, Store } from '@ngxs/store';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LoginAction } from '../core/authentication/auth.state.model';
import { AuthModel } from '../core/authentication/auth.model';
import { AppSelectors } from '../app.state';
import { TranslocoModule } from '@jsverse/transloco';
import { InactivityService } from '../core/services/inactivity.service';

@Component({
  selector: 'pixl-login',
  imports: [
    MatCard,
    MatFormField,
    MatButton,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    TranslocoModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  store = inject(Store);
  fb = inject(FormBuilder);
  inactivityService = inject(InactivityService);
  private route = inject(ActivatedRoute);

  authState = select(AppSelectors.authState);

  authModel: AuthModel = {
    email: '',
    password: ''
  };

  loginForm = this.fb.group({
    email: [this.authModel.email, [Validators.required, Validators.email]],
    password: [this.authModel.password, [Validators.required]]
  });

  sendLogin() {
    this.inactivityService.wasAutoLoggedOut.set(false);
    if (this.loginForm.valid) {
      Object.assign(this.authModel, this.loginForm.value);
      const redirectTo = this.route.snapshot.queryParamMap.get('redirect_to');
      this.store.dispatch(new LoginAction(this.authModel, redirectTo));
    }
  }
}
